import { motion, useReducedMotion } from 'motion/react'

const GLOW_SECONDS = 1.6

export const TourRing = ({ hole }: { hole: DOMRect }) => {
  const reduceMotion = useReducedMotion() ?? false

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none fixed z-[45] rounded-lg border-2 border-brand"
      style={{
        top: hole.top,
        left: hole.left,
        width: hole.width,
        height: hole.height,
      }}
      initial={reduceMotion ? false : { opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      {!reduceMotion && (
        <motion.span
          className="absolute -inset-1.5 rounded-xl border-4 border-brand/30"
          animate={{ opacity: [0.3, 1, 0.3] }}
          transition={{
            duration: GLOW_SECONDS,
            repeat: Number.POSITIVE_INFINITY,
            ease: 'easeInOut',
          }}
        />
      )}
    </motion.div>
  )
}
